(() => {
  const init=()=>{
    const root=document.querySelector('[data-live-product]');
    const bar=root?.querySelector('[data-mobile-purchase]');
    const form=root?.querySelector('[data-single-form]');
    const mainButton=form?.querySelector('[data-single-add]');
    if(!bar||!form||!mainButton||form.dataset.enhanced!=='true')return;
    const button=bar.querySelector('[data-mobile-add]');
    const mobile=matchMedia('(max-width:700px)');
    const sync=()=>{
      const choice=form.querySelector('[name=id]');
      const selected=choice?.value;
      const color=form.querySelector('[data-color][aria-pressed="true"]')?.dataset.color||'';
      const size=form.querySelector('[data-size][aria-pressed="true"]')?.dataset.size||'';
      bar.querySelector('[data-mobile-price]').textContent=form.querySelector('[data-single-button-price]').textContent;
      bar.querySelector('[data-mobile-selection]').textContent=selected?[color,size].filter(Boolean).join(' · '):bar.dataset.sizePrompt;
      button.textContent=selected?bar.dataset.addLabel:bar.dataset.chooseLabel;
      button.disabled=mainButton.disabled;
    };
    const visibility=()=>{
      const show=mobile.matches&&mainButton.getBoundingClientRect().bottom<0;
      bar.hidden=!show;
      document.body.classList.toggle('av-mobile-purchase-visible',show);
    };
    button.addEventListener('click',()=>{
      if(!form.querySelector('[name=id]')?.value){
        const sizes=form.querySelector('[data-single-sizes]');
        sizes?.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
        sizes?.querySelector('button:not([disabled])')?.focus({preventScroll:true});
        return;
      }
      form.requestSubmit(mainButton);
    });
    new MutationObserver(sync).observe(form,{subtree:true,attributes:true,childList:true,characterData:true});
    new IntersectionObserver(visibility,{threshold:0}).observe(mainButton);
    let pending=false;
    window.addEventListener('scroll',()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{visibility();pending=false;});},{passive:true});
    window.addEventListener('resize',visibility,{passive:true});
    mobile.addEventListener('change',visibility);
    sync();visibility();
  };
  if(document.readyState==='complete')init();else document.addEventListener('DOMContentLoaded',init,{once:true});
})();